import {ApplicationConfig, LOCALE_ID, provideZoneChangeDetection} from '@angular/core';
import {provideRouter, RouteReuseStrategy} from '@angular/router';
import { provideDatadogErrorHandler, provideDatadogRouter } from '@datadog/browser-rum-angular';
import { provideHttpClient } from '@angular/common/http';

import { routes } from './app.routes';
import { ParamAwareRouteReuseStrategy } from './shared/utils/param-aware-route-reuse.strategy';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    // Vues RUM nommées par le motif de route (/leases/:id), pas par l'URL.
    provideDatadogRouter(),
    // Un autre :id = un autre écran, reconstruit. Voir la classe.
    { provide: RouteReuseStrategy, useClass: ParamAwareRouteReuseStrategy },
    provideHttpClient(),
    // Remplace l'ErrorHandler d'Angular : l'erreur part dans Datadog RUM et
    // reste affichée dans la console.
    provideDatadogErrorHandler(),

    {
      provide: LOCALE_ID,
      useValue: 'fr'
    }
  ]
};
